"use client"

import { CalendarCog } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CalendarCogIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CalendarCogIcon = component(Icon)({ as: CalendarCog })
